import { AiccVoiceGender } from "types/model/aiccLearningAssets";

export const AICC_VOICE_GENDER: Record<AiccVoiceGender, AiccVoiceGender> = {
  male: "male",
  female: "female",
};

export const AICC_VOICE_GENDER_LABEL: Record<AiccVoiceGender, string> = {
  [AICC_VOICE_GENDER.male]: "MALE",
  [AICC_VOICE_GENDER.female]: "FEMALE",
};
